import { defineStore } from "pinia";

import api from "@//plugins/api";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    isAuthenticated: false,
    user: {
      name: null,
      user: null,
      email: null,
      role: null,
      rfc: null,
      credential_init: null,
      credential_end: null,
    },
  }),

  getters: {
    getRole: (state) => state.user.role,
  },

  actions: {
    isUserAuthenticated() {
      return this.isAuthenticated;
    },
    setAuth(payload) {
      this.isAuthenticated = true;
      this.user = payload.user;

      window.localStorage.setItem("token", payload.token);
    },
    getToken() {
      return window.localStorage.getItem("token");
    },
    destroyToken() {
      window.localStorage.removeItem("token");
    },
    purgeAuth() {
      console.log("purgeAuth");
      this.isAuthenticated = false;
      this.user = {};
      // this.errors = [];
      this.destroyToken();
    },
    async verifyAuth(token) {
      try {
        // console.info("Verify Authorization");
        if (!this.getToken()) throw "No auth token available";
        const response = await api.post(`v1/verify-token`, { token });

        this.setAuth(response.data);
      } catch (error) {
        // this.context.commit(Mutations.SET_ERROR, response.data.errors);
        this.purgeAuth();
      }
    },
  },
});
